<template>
  <div>
    <div class="component-title">
      <div class="component-title">
        <h1 class="">Financial Capacity</h1>
      </div>
    </div>

    <form id="form9" autocomplete="off" class="mt-40">
      <div
        class="row Introduce-yourself-container"
        style="font-size: 20px; margin: 0 auto"
      >
        <div class="row pt-10 flx justify-content-between align-items-end">
          <div class="col-sm-6 col-md-6">
            <div class="flx justify-content-between align-items-center">
              <span>Net Income from your Primary Employer</span>
              <div class="help-icon">
                <img
                  src="https://mps.ccfunding.com.au/images/help-icon.png"
                  class="img-100"
                />
                <span class="question-tips"
                  >This is your income after tax.</span
                >
              </div>
            </div>
            <input
              type="text"
              value="0"
              name="netIncome"
              required=""
              placeholder=""
              class="netIncome"
            />
          </div>
          <div class="col-sm-6 col-md-6 flx align-items-end">
            <div class="toggle">
              <input
                type="radio"
                name="netIncomeRadio"
                value="weekly"
                id="netIncomeWeekly"
                class="netIncome"
                required=""
                checked=""
              />
              <label class="default mt-10" for="netIncomeWeekly">Weekly</label>
              <input
                type="radio"
                name="netIncomeRadio"
                value="fortnightly"
                class="netIncome"
                id="netIncomeFortnightly"
                required=""
              />
              <label class="default mt-10" for="netIncomeFortnightly"
                >Fortnightly</label
              >
              <input
                type="radio"
                name="netIncomeRadio"
                value="monthly"
                class="netIncome"
                id="netIncomeMonthly"
                required=""
              />
              <label class="default mt-10" for="netIncomeMonthly"
                >Monthly</label
              >
            </div>
            <label
              id="netIncomeRadio-error"
              class="error"
              for="netIncomeRadio"
            ></label>
          </div>
        </div>

        <div class="row pt-10 flx align-items-end">
          <div class="col-sm-6 col-md-6">
            <div class="flx justify-content-between align-items-center">
              <span>Other Income</span>
              <div class="help-icon">
                <img
                  src="https://mps.ccfunding.com.au/images/help-icon.png"
                  class="img-100"
                />
                <span class="question-tips"
                  >This is any other regular income that you receive after tax.
                </span>
              </div>
            </div>
            <input
              type="text"
              value="0"
              name="otherIncome[0][income]"
              id="otherIncome[0]"
              class="netincome"
              required=""
              placeholder=""
            />
          </div>
          <div class="col-sm-6 col-md-6 flx align-items-end">
            <div class="toggle">
              <input
                type="radio"
                name="otherIncome[0][Incomefrequency]"
                value="weekly"
                class="netIncome"
                id="otherIncomeWeekly[0]"
                required=""
                checked=""
              />
              <label class="default mt-10" for="otherIncomeWeekly[0]"
                >Weekly</label
              >
              <input
                type="radio"
                name="otherIncome[0][Incomefrequency]"
                value="fortnightly"
                class="netIncome"
                id="otherIncomeFortnightly[0]"
                required=""
              />
              <label class="default mt-10" for="otherIncomeFortnightly[0]"
                >Fortnightly</label
              >
              <input
                type="radio"
                name="otherIncome[0][Incomefrequency]"
                value="monthly"
                class="netIncome"
                id="otherIncomeMonthly[0]"
                required=""
              />
              <label class="default mt-10" for="otherIncomeMonthly[0]"
                >Monthly</label
              >
            </div>
            <label
              id="otherIncomeRadio-error"
              class="error"
              for="otherIncomeRadio"
            ></label>
          </div>
        </div>
        <div v-for="item in income" :key="item.id">
                  <p v-html="item.description"></p>
              </div>
        <div class="flx change-employment-btn pt-10 pointer" @click="addIncome()">
          <div class="add-icon">+</div>
          <span>Add Other Income</span>
        </div>
        <div class="pt-10">
          <div class="row flx align-items-end">
            <div class="col-sm-6 col-md-6">
              <div class="col-sm-6 col-md-6" style="padding-left: 0">
                <span>Residential Status</span>
                <select required="required" name="residential_status">
                  <option selected="selected" value="">Select</option>
                  <option value="Mortage">Mortage</option>
                  <option value="Renting">Renting</option>
                  <option value="Owned">Owned</option>
                  <option value="Boarding">Boarding</option>
                  <option value="Living with Parents">
                    Living with Parents
                  </option>
                </select>
              </div>
              <div class="col-sm-6 col-md-6" style="padding: 0 0 0 0">
                <span>Repayment Amount</span>
                <input
                  type="text"
                  value="0"
                  name="bill[0][utility]"
                  placeholder=""
                  required=""
                  class="netIncome"
                />
              </div>
            </div>
            <div class="col-sm-6 col-md-6 flx align-items-end">
              <div class="toggle">
                <input
                  type="radio"
                  name="bill[0][frequency]"
                  value="weekly"
                  class="netIncome"
                  id="repaymentAmountWeekly"
                  required=""
                  checked=""
                />
                <label class="default mt-10" for="repaymentAmountWeekly"
                  >Weekly</label
                >
                <input
                  type="radio"
                  name="bill[0][frequency]"
                  value="fortnightly"
                  class="netIncome"
                  id="repaymentAmountFortnightly"
                  required=""
                />
                <label class="default mt-10" for="repaymentAmountFortnightly"
                  >Fortnightly</label
                >
                <input
                  type="radio"
                  name="bill[0][frequency]"
                  value="monthly"
                  class="netIncome"
                  id="repaymentAmountMonthly"
                  required=""
                />
                <label class="default mt-10" for="repaymentAmountMonthly"
                  >Monthly</label
                >
              </div>
              <label
                id="repaymentAmountRadio-error"
                class="error"
                for="repaymentAmountRadio"
              ></label>
            </div>
          </div>

          <div class="row pt-10 flx align-items-end">
            <div class="col-sm-6 col-md-6">
              <div class="col-sm-6 col-md-6"></div>
              <div class="col-sm-6 col-md-6" style="padding: 0 0 0 0">
                <div class="flx justify-content-between align-items-center">
                  <span>Utilities Bills</span>
                  <div class="help-icon">
                    <img
                      src="https://mps.ccfunding.com.au/images/help-icon.png"
                      class="img-100"
                    />
                    <span class="question-tips">
                      Bills for using services that are generally associated
                      with households.
                    </span>
                  </div>
                </div>
                <input
                  type="text"
                  class="netIncome"
                  value="0"
                  name="bill[1][utility]"
                  required=""
                  placeholder=""
                />
              </div>
            </div>
            <div class="col-sm-6 col-md-6 flx align-items-end">
              <div class="toggle">
                <input
                  type="radio"
                  name="bill[1][frequency]"
                  value="weekly"
                  class="netIncome"
                  id="utilitiesBillsWeekly"
                  required=""
                  checked=""
                />
                <label class="default mt-10" for="utilitiesBillsWeekly"
                  >Weekly</label
                >
                <input
                  type="radio"
                  name="bill[1][frequency]"
                  value="fortnightly"
                  class="netIncome"
                  id="utilitiesBillsFortnightly"
                  required=""
                />
                <label class="default mt-10" for="utilitiesBillsFortnightly"
                  >Fortnightly</label
                >
                <input
                  type="radio"
                  name="bill[1][frequency]"
                  value="monthly"
                  class="netIncome"
                  id="utilitiesBillsMonthly"
                  required=""
                />
                <label class="default mt-10" for="utilitiesBillsMonthly"
                  >Monthly</label
                >
              </div>
              <label
                id="utilitiesBillsRadio-error"
                class="error"
                for="utilitiesBillsRadio"
              ></label>
            </div>
          </div>
          <div class="row pt-10 flx align-items-end">
            <div class="col-sm-6 col-md-6">
              <div class="col-sm-6 col-md-6"></div>
              <div class="col-sm-6 col-md-6" style="padding: 0 0 0 0">
                <div class="flx justify-content-between align-items-center">
                  <span>Household Bills</span>
                  <div class="help-icon">
                    <img
                      src="https://mps.ccfunding.com.au/images/help-icon.png"
                      class="img-100"
                    />
                    <span class="question-tips">
                      Bills for household expenses, like food and groceries.
                    </span>
                  </div>
                </div>
                <input
                  type="text"
                  class="netIncome"
                  value="0"
                  name="bill[2][utility]"
                  required=""
                  placeholder=""
                />
              </div>
            </div>
            <div class="col-sm-6 col-md-6 flx align-items-end">
              <div class="toggle">
                <input
                  type="radio"
                  name="bill[2][frequency]"
                  value="weekly"
                  class="netIncome"
                  id="householdBillsWeekly"
                  required=""
                  checked=""
                />
                <label class="default mt-10" for="householdBillsWeekly"
                  >Weekly</label
                >
                <input
                  type="radio"
                  name="bill[2][frequency]"
                  value="fortnightly"
                  class="netIncome"
                  id="householdBillsFortnightly"
                  required=""
                />
                <label class="default mt-10" for="householdBillsFortnightly"
                  >Fortnightly</label
                >
                <input
                  type="radio"
                  name="bill[2][frequency]"
                  value="monthly"
                  class="netIncome"
                  id="householdBillsMonthly"
                  required=""
                />
                <label class="default mt-10" for="householdBillsMonthly"
                  >Monthly</label
                >
              </div>
              <label
                id="householdBillsRadio-error"
                class="error"
                for="householdBillsRadio"
              ></label>
            </div>
          </div>
          <div class="row pt-10 flx align-items-end">
            <div class="col-sm-6 col-md-6">
              <div class="col-sm-6 col-md-6"></div>
              <div class="col-sm-6 col-md-6" style="padding: 0 0 0 0">
                <div class="flx justify-content-between align-items-center">
                  <span>Medical Bills</span>
                  <div class="help-icon">
                    <img
                      src="https://mps.ccfunding.com.au/images/help-icon.png"
                      class="img-100"
                    />
                    <span class="question-tips">
                      Bills for medical expenses including prescription,
                      pharmacy, doctor visits etc.
                    </span>
                  </div>
                </div>
                <input
                  type="text"
                  class="netIncome"
                  value="0"
                  name="bill[3][utility]"
                  required=""
                  placeholder=""
                />
              </div>
            </div>
            <div class="col-sm-6 col-md-6 flx align-items-end">
              <div class="toggle">
                <input
                  type="radio"
                  name="bill[3][frequency]"
                  value="weekly"
                  class="netIncome"
                  id="medicalBillsWeekly"
                  required=""
                  checked=""
                />
                <label class="default mt-10" for="medicalBillsWeekly"
                  >Weekly</label
                >
                <input
                  type="radio"
                  name="bill[3][frequency]"
                  value="fortnightly"
                  class="netIncome"
                  id="medicalBillsFortnightly"
                  required=""
                />
                <label class="default mt-10" for="medicalBillsFortnightly"
                  >Fortnightly</label
                >
                <input
                  type="radio"
                  name="bill[3][frequency]"
                  value="monthly"
                  class="netIncome"
                  id="medicalBillsMonthly"
                  required=""
                />
                <label class="default mt-10" for="medicalBillsMonthly"
                  >Monthly</label
                >
              </div>
              <label
                id="medicalBillsRadio-error"
                class="error"
                for="medicalBillsRadio"
              ></label>
            </div>
          </div>
          <div class="row pt-10 flx align-items-end">
            <div class="col-sm-6 col-md-6">
              <div class="col-sm-6 col-md-6"></div>
              <div class="col-sm-6 col-md-6" style="padding: 0 0 0 0">
                <div class="flx justify-content-between align-items-center">
                  <span>Insurance Bills</span>
                  <div class="help-icon">
                    <img
                      src="https://mps.ccfunding.com.au/images/help-icon.png"
                      class="img-100"
                    />
                    <span class="question-tips">
                      Expenses including health insurance, home insurance etc.
                    </span>
                  </div>
                </div>
                <input
                  type="text"
                  class="netIncome"
                  value="0"
                  name="bill[4][utility]"
                  required=""
                  placeholder=""
                />
              </div>
            </div>
            <div class="col-sm-6 col-md-6 flx align-items-end">
              <div class="toggle">
                <input
                  type="radio"
                  name="bill[4][frequency]"
                  value="weekly"
                  class="netIncome"
                  id="insuranceBillsWeekly"
                  required=""
                  checked=""
                />
                <label class="default mt-10" for="insuranceBillsWeekly"
                  >Weekly</label
                >
                <input
                  type="radio"
                  name="bill[4][frequency]"
                  value="fortnightly"
                  class="netIncome"
                  id="insuranceBillsFortnightly"
                  required=""
                />
                <label class="default mt-10" for="insuranceBillsFortnightly"
                  >Fortnightly</label
                >
                <input
                  type="radio"
                  name="bill[4][frequency]"
                  value="monthly"
                  class="netIncome"
                  id="insuranceBillsMonthly"
                  required=""
                />
                <label class="default mt-10" for="insuranceBillsMonthly"
                  >Monthly</label
                >
              </div>
              <label
                id="insuranceBillsRadio-error"
                class="error"
                for="insuranceBillsRadio"
              ></label>
            </div>
          </div>
          <div class="row pt-10 flx align-items-end">
            <div class="col-sm-6 col-md-6">
              <div class="col-sm-6 col-md-6"></div>
              <div class="col-sm-6 col-md-6" style="padding: 0 0 0 0">
                <div class="flx justify-content-between align-items-center">
                  <span>Entertainment</span>
                  <div class="help-icon">
                    <img
                      src="https://mps.ccfunding.com.au/images/help-icon.png"
                      class="img-100"
                    />
                    <span class="question-tips">
                      Costs associated with going out for entertainment
                      purposes. Example: going out for dinners, going out for
                      movies etc
                    </span>
                  </div>
                </div>
                <input
                  type="text"
                  class="netIncome"
                  value="0"
                  name="bill[5][utility]"
                  required=""
                  placeholder=""
                />
              </div>
            </div>
            <div class="col-sm-6 col-md-6 flx align-items-end">
              <div class="toggle">
                <input
                  type="radio"
                  name="bill[5][frequency]"
                  value="weekly"
                  class="netIncome"
                  id="entertainmentWeekly"
                  required=""
                  checked=""
                />
                <label class="default mt-10" for="entertainmentWeekly"
                  >Weekly</label
                >
                <input
                  type="radio"
                  name="bill[5][frequency]"
                  value="fortnightly"
                  class="netIncome"
                  id="entertainmentFortnightly"
                  required=""
                />
                <label class="default mt-10" for="entertainmentFortnightly"
                  >Fortnightly</label
                >
                <input
                  type="radio"
                  name="bill[5][frequency]"
                  value="monthly"
                  class="netIncome"
                  id="entertainmentMonthly"
                  required=""
                />
                <label class="default mt-10" for="entertainmentMonthly"
                  >Monthly</label
                >
              </div>
              <label
                id="entertainmentRadio-error"
                class="error"
                for="entertainmentRadio"
              ></label>
            </div>
          </div>
          <div class="row pt-10 flx align-items-end">
            <div class="col-sm-6 col-md-6">
              <div class="col-sm-6 col-md-6"></div>
              <div class="col-sm-6 col-md-6" style="padding: 0 0 0 0">
                <div class="flx justify-content-between align-items-center">
                  <span>Phone/Internet Bill</span>
                  <div class="help-icon">
                    <img
                      src="https://mps.ccfunding.com.au/images/help-icon.png"
                      class="img-100"
                    />
                    <span class="question-tips">
                      Costs associated with phone and internet bills.
                    </span>
                  </div>
                </div>
                <input
                  type="text"
                  class="netIncome"
                  value="0"
                  name="bill[6][utility]"
                  required=""
                  placeholder=""
                />
              </div>
            </div>
            <div class="col-sm-6 col-md-6 flx align-items-end">
              <div class="toggle">
                <input
                  type="radio"
                  name="bill[6][frequency]"
                  value="weekly"
                  class="netIncome"
                  id="phone/internetBillWeekly"
                  required=""
                  checked=""
                />
                <label class="default mt-10" for="phone/internetBillWeekly"
                  >Weekly</label
                >
                <input
                  type="radio"
                  name="bill[6][frequency]"
                  value="fortnightly"
                  class="netIncome"
                  id="phone/internetBillFortnightly"
                  required=""
                />
                <label class="default mt-10" for="phone/internetBillFortnightly"
                  >Fortnightly</label
                >
                <input
                  type="radio"
                  name="bill[6][frequency]"
                  value="monthly"
                  class="netIncome"
                  id="phone/internetBillMonthly"
                  required=""
                />
                <label class="default mt-10" for="phone/internetBillMonthly"
                  >Monthly</label
                >
              </div>
              <label
                id="phone/internetBillRadio-error"
                class="error"
                for="phone/internetBillRadio"
              ></label>
            </div>
          </div>
        </div>

        <div class="row pt-20">
          <div class="col-sm-3 col-md-3"></div>
          <div class="col-sm-9 col-md-9" style="padding-left: 0">
            <p>Nett Income - Expenses = $<span id="net"></span></p>
            <p id="net-error-msg" style="color: red">
              *Oh no! It looks like you may not have the capacity to meet your
              repayments according to the information you've supplied.
            </p>
            <input type="hidden" id="totalNetIncome" name="totalNetIncome" />
          </div>
        </div>
      </div>
    </form>

    <div class="flx loan-container mt-60">
      <a
        type="button"
        class="continue-btn continue-btn-small steps-btn"
        href="#"
        @click.prevent="onContinue('employment-details')"
        >BACK</a
      >
      <a
        type="button"
        class="continue-btn continue-btn-small continue-btn-small-right steps-btn"
        href="#"
        @click.prevent="onContinue('financial-capacity-2')"
        >CONTINUE</a
      >
    </div>
    <div class="mt-60 clear"></div>
  </div>
</template>

<script>
export default {
  props: ["onChangeStep"],
  data: ()=>{
    return {income: []}
  },
  methods: {
    onContinue(step) {
      this.onChangeStep(step);
    },
    addIncome(){
      var new_id = 0;
      do{++new_id;}while(this.income.find(e => e.id === new_id));
      let incomeTemplate = `
      <div class="income-container mt-20 income-`+new_id+`">
            <div class="row pt-10 flx align-items-end">
              <div class="col-sm-6 col-md-6">
                <div class="flx justify-content-between align-items-center">
                  <span>Other Income</span>
                  <div class="help-icon">
                    <img
                      src="https://mps.ccfunding.com.au/images/help-icon.png"
                      class="img-100"
                    />
                    <span class="question-tips"
                      >This is any other regular income that you receive after tax.
                    </span>
                  </div>
                </div>
                <input
                  type="text"
                  value="0"
                  name="otherIncome[`+new_id+`][income]"
                  id="otherIncome[`+new_id+`]"
                  class="netincome"
                  required=""
                  placeholder=""
                />
              </div>
              <div class="col-sm-6 col-md-6 flx align-items-end">
                <div class="toggle">
                  <input
                    type="radio"
                    name="otherIncome[`+new_id+`][Incomefrequency]"
                    value="weekly"
                    class="netIncome"
                    id="otherIncomeWeekly[`+new_id+`]"
                    required=""
                    checked=""
                  />
                  <label class="default mt-10" for="otherIncomeWeekly[`+new_id+`]"
                    >Weekly</label
                  >
                  <input
                    type="radio"
                    name="otherIncome[`+new_id+`][Incomefrequency]"
                    value="fortnightly"
                    class="netIncome"
                    id="otherIncomeFortnightly[`+new_id+`]"
                    required=""
                  />
                  <label class="default mt-10" for="otherIncomeFortnightly[`+new_id+`]"
                    >Fortnightly</label
                  >
                  <input
                    type="radio"
                    name="otherIncome[`+new_id+`][Incomefrequency]"
                    value="monthly"
                    class="netIncome"
                    id="otherIncomeMonthly[`+new_id+`]"
                    required=""
                  />
                  <label class="default mt-10" for="otherIncomeMonthly[`+new_id+`]"
                    >Monthly</label
                  >
                </div>
                <label
                  id="otherIncomeRadio-error"
                  class="error"
                  for="otherIncomeRadio"
                ></label>
              </div>
            </div>
            <div class="row pt-10">
                <div class="col-sm-6 col-md-6">
                    <button class="btn btn-danger" onclick="$(this).closest('.income-container').remove()">Remove income</button>
                </div>
            </div>
        </div>

      </div>
      `;
      
      this.income.push({
        id: new_id,
        description: incomeTemplate,
      });
    },
  },
};
</script>
